module.exports = __webpack_public_path__ + "img/ones.83f0238c.png";